<template>
  <div :class="'modifierBox ' + (remaining ? 'unpaid' : '')">
    <li>
      <div class="box">
        <p style="text-align: center">
          <span class="modifier-name"
            >{{ order.name || "No Name / Table No." }}<b class="name_right">{{ order.delivery_option }}</b></span
          >
          <span class="modifier-price">{{ time }}</span>
          <span class="modifier-products">
            <ul>
              <li class="lineItem" v-for="product in order.products" v-bind:key="product">
                <div class="lineItemSummary">
                  <span class="lineItemName">{{ product.item }} <span class="times"> x </span>{{ product.quantity }}</span>
                  <span class="lineItemTotal"><CurrencyFormatter :value="parseFloat(product.price * product.quantity)" :currency="currency"/></span>

                  

                </div>
                <ul class="modifiers">
                  <li v-for="modifiers in product.modifiers" :key="product.hash + '-' + modifiers">
                    <div v-for="modifier in modifiers" :key="modifier">
                      <span class="submodifier-name">{{ modifier.name }}</span>
                      <span class="submodifier-total" v-if="modifier.price"><CurrencyFormatter :value="modifier.price" :currency="currency"/></span>
                      <span class="submodifier-total" v-else>0.00</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </span>
          <span class="modifier-total">
            <!-- <span>Total: </span><span>{{ renderTotal }}</span> -->
            <span>Total: </span><span><CurrencyFormatter :value="this.total" :currency="currency"/></span>
          </span>
          <span class="modifier-total">
            <span>Paid: </span><span> <CurrencyFormatter :value="this.paid" :currency="currency"/></span>
          </span>
          <span class="modifier-total">
            <span>Balance: </span><span> <CurrencyFormatter :value="this.remaining" :currency="currency"/></span>
          </span>
        </p>
      </div>
    </li>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { CurrencyFormatter } from "@monolith/components";
import { mapGetters } from "vuex";

export default {
  name: "HistoryOrder",
  props: ["order"],
  methods: {
  },
  components: {CurrencyFormatter},
  
  computed: {
    ...mapGetters({
      currency: "currency"
    }),
    time() {
      var d = dayjs(this.order.created_at);
      return d.format("hh:mma DD/MM/YYYY");
    },
    total() {
      if (this.order.products !== undefined) {
        return this.order.products.reduce((runningTotal, product) => {
          return runningTotal + product.price * product.quantity;
        }, 0);
      } else {
        return 0;
      }
    },
    paid() {
      if (this.order.payments !== undefined) {
        return this.order.payments.reduce((runningTotal, payment) => {
          return runningTotal + parseFloat(payment.value);
        }, 0);
      } else {
        return 0;
      }
    },
    remaining() {
      return this.total - this.paid;
    },
  },
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.unpaid {
  background-color: var(--secondary-colour) !important;
}

.name_right {
  float: right;
}

h2 {
  margin-top: 0px;
  padding-top: 1rem;

  span:nth-of-type(2) {
    color: #aaa;
  }

  cursor: pointer;
}

ul.wrapper {
  grid-template-columns: repeat(1, minmax(0, 1fr));

  .modifierBox {
    .modifier-total {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
    }

    li.lineItem {
      margin-bottom: 1rem !important;

      .lineItemSummary {
        display: flex;

        .lineItemName {
          flex: 1 1;
          display: inline-block;
          text-align: left;
        }

        .lineItemTotal {
          flex: 0 0;
          display: inline-block;
          text-align: right;
        }
      }
    }

    ul.modifiers {
      border-bottom: 1px solid #ccc;
      font-size: 0.8em;

      li {
        list-style: none;
      }

      li div {
        display: flex;
        .submodifier-name {
          flex: 1 1;
          display: inline-block;
          text-align: left;
        }

        .submodifier-total {
          flex: 0 0;
          display: inline-block;
          text-align: right;
        }
      }

      margin: 0px;
      padding: 0px;
    }
  }
}
</style>
